





















































import { Component, Ref, Vue, Watch } from "vue-property-decorator";
import PictureInput from "vue-picture-input";
import EXIF from "exif-js";

import ExifTable from "@/components/ExifTable.vue";
import WrappedImage from "@/components/WrappedImage.vue";
import { ChallengeResult } from "@/models/definitions";

@Component({
  components: {
    ExifTable,
    PictureInput,
    WrappedImage,
  },
})
export default class ChallengeDetails extends Vue {
  @Ref() readonly pictureInput!: any;

  private imageToUpload: string | null = null;
  private exifData: any | null = null;
  private imageProcessed = false;

  get challengeResult() {
    return this.$store.getters.oneChallengeResult(this.$route.params.id);
  }

  get challenge() {
    return this.challengeResult ? this.challengeResult.challenge : undefined;
  }

  get submission() {
    return this.challengeResult ? this.challengeResult.submission : undefined;
  }

  mounted() {
    if (this.challenge && this.submission && this.submission.exif) {
      this.exifData = this.submission.exif;
    }
  }

  @Watch("challengeResult")
  onChildChanged(val: ChallengeResult, _: ChallengeResult) {
    if (val.submission && val.submission.exif) {
      this.exifData = val.submission.exif;
    }
  }

  onChange() {
    this.imageProcessed = false;
    if (this.pictureInput.file) {
      this.imageToUpload = this.pictureInput.file;

      this.exifData = null;
      EXIF.getData(this.pictureInput.file, () => {
        this.exifData = EXIF.getAllTags(this.pictureInput.file);
        this.imageProcessed = true;
      });
    } else {
      console.log("Old browser. No support for Filereader API");
    }
  }

  attemptUpload() {
    if (this.imageProcessed && this.imageToUpload) {
      this.$store
        .dispatch("submitImage", {
          challenge: this.$route.params.id,
          image: this.imageToUpload,
          exifData: JSON.stringify(this.exifData),
        })
        .then(() => {
          this.pictureInput.removeImage();
        });
    }
  }
}
